/** Native app listings — keep in sync with band-space-landing */
export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.band_space.twa&hl=en';

const APP_STORE_URL_FALLBACK =
  'https://apps.apple.com/us/app/band-space-app/id6760477252';

export const APP_STORE_URL =
  (typeof process !== 'undefined' && process.env.REACT_APP_APP_STORE_URL) ||
  APP_STORE_URL_FALLBACK;
